import React from 'react';
import { Paper, Typography, Button, Box } from '@mui/material';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ReplyIcon from '@mui/icons-material/Reply';
import commentsData from '../data/comments.json';

// You can either pass a specific comment as a prop or fetch all comments
const Comment = ({ commentId }) => {
  // Find the specific comment from the JSON data
  const comment = commentsData.comments.find(c => c.id === commentId);

  if (!comment) return null;

  return (
    <Paper 
      elevation={0} 
      sx={{ 
        p: 3, 
        mb: 2, 
        border: 1, 
        borderColor: 'divider',
        '&:hover': {
          borderColor: 'primary.light',
          backgroundColor: 'rgba(44, 62, 80, 0.02)'
        }
      }}
    >
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        mb: 2,
        alignItems: 'center'
      }}>
        <Typography 
          fontWeight="bold" 
          color="primary.main"
          sx={{ fontSize: '1.1rem' }}
        >
          {comment.author}
        </Typography>
        <Typography 
          color="text.secondary" 
          variant="body2"
        >
          {new Date(comment.timestamp).toLocaleDateString()}
        </Typography>
      </Box>

      <Typography 
        variant="body1" 
        sx={{ 
          mb: 3,
          lineHeight: 1.7,
          color: 'text.primary'
        }}
      >
        {comment.content}
      </Typography>

      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button 
          startIcon={<ThumbUpIcon />} 
          size="small"
          sx={{ 
            color: 'text.secondary',
            '&:hover': {
              color: 'primary.main',
              backgroundColor: 'rgba(44, 62, 80, 0.04)'
            }
          }}
        >
          {comment.likes}
        </Button>
        <Button 
          startIcon={<ReplyIcon />} 
          size="small"
          sx={{ 
            color: 'text.secondary',
            '&:hover': {
              color: 'primary.main',
              backgroundColor: 'rgba(44, 62, 80, 0.04)'
            }
          }}
        >
          Reply
        </Button>
      </Box>
    </Paper>
  );
};

// You might also want a CommentList component to display all comments:
export const CommentList = () => {
  const { comments } = commentsData;

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h6" sx={{ mb: 3 }}>
        Comments ({comments.length})
      </Typography>
      {comments.map(comment => (
        <Comment key={comment.id} commentId={comment.id} />
      ))}
    </Box>
  );
};

export default Comment; 